import React, { useEffect, useState } from "react";
import { Alert, Container, Tab, Tabs } from "react-bootstrap";
import { apiGet } from "./content/contentApi";
import MediaItemsTab from "./content/MediaItemsTab";
import TestsTab from "./content/TestsTab";

const ContentManagement = () => {
    const [levels, setLevels] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        apiGet("/levels")
            .then((data) => setLevels(data || []))
            .catch((err) => setError(`Failed to load levels: ${err.message}`));
    }, []);

    return (
        <Container className="mt-4">
            <h3 className="mb-3">Content</h3>

            {error && <Alert variant="danger">{error}</Alert>}

            {/* Tabs stay mounted, so each tab keeps its filters when switching. */}
            <Tabs defaultActiveKey="media" id="content-tabs" className="mb-3" mountOnEnter>
                <Tab eventKey="media" title="Media items">
                    <MediaItemsTab levels={levels} />
                </Tab>
                <Tab eventKey="tests" title="Tests">
                    <TestsTab levels={levels} />
                </Tab>
            </Tabs>
        </Container>
    );
};

export default ContentManagement;
